import React from 'react'
import logo from './headerlogo.png'
import { Link } from 'gatsby'

const OurAssociates = props => {
  return (
    <ul
      className="children"
      style={{ display: props.visible }}
      onMouseLeave={props.ourAssociatesOnMouseLeave}
    >
      <li className="page_item page-item-335 current_page_item">
        <Link to="/our-associates/elfego-gomez-iii">Elfego Gomez III</Link>
      </li>
      <li className="page_item page-item-342">
        <Link to="/our-associates/shanna-r-teel-ph">Shanna R. Teel, PhD</Link>
      </li>
      <li className="page_item page-item-416">
        <Link to="/our-associates/edwin-bodensiek">Edwin Bodensiek</Link>
      </li>
      <li className="page_item page-item-354">
        <Link to="/our-associates/stuart-parsons">Stuart Parsons</Link>
      </li>
      <li className="page_item page-item-350">
        <Link to="/our-associates/joette-borzik">Joette Borzik</Link>
      </li>
      <li className="page_item page-item-405">
        <Link to="/our-associates/mimi-azoubel-daniel-m-s-pcc">
          Mimi Azoubel Daniel, M.S., PCC
        </Link>
      </li>
      <li className="page_item page-item-258">
        <Link to="/our-associates/steve-rudolph">Steve Rudolph</Link>
      </li>
      <li className="page_item page-item-254">
        <Link to="/our-associates/michael-s-patterson-md">
          Michael S. Patterson, MD
        </Link>
      </li>
      <li className="page_item page-item-295">
        <Link to="/our-associates/christopher-lowell">Christopher Lowell</Link>
      </li>
    </ul>
  )
}

const WhatWeDo = props => (
  <ul
    className="children"
    style={{ display: props.visible }}
    onMouseLeave={props.whatWeDoOnMouseLeave}
  >
    <li className="page_item page-item-131">
      <Link to="/what-we-do#consulting-expertise">Consulting Expertise</Link>
    </li>
    <li className="page_item page-item-135">
      <Link to="/what-we-do#special-programs-and-selected-simulations">
        Special Programs and Selected Simulations
      </Link>
    </li>
    <li className="page_item page-item-137">
      <Link to="/what-we-do#full-day-and-multi-day-Modules-and-training-course">
        Full Day &amp; Multi Day Modules &amp; Training Courses
      </Link>
    </li>
    <li className="page_item page-item-142">
      <Link to="/what-we-do#half-day-modules-and-training-courses">
        Half Day Modules &amp; Training Courses
      </Link>
    </li>
    <li className="page_item page-item-146">
      <Link to="/what-we-do#certifications">Certifications</Link>
    </li>
  </ul>
)

const Header = class extends React.Component {
  constructor() {
    super()
    this.state = {
      ourAssociatesVisibility: 'none',
      whatWeDoVisibility: 'none',
    }
  }

  async showAssociates(event) {
    event.preventDefault()
    this.setState({
      ourAssociatesVisibility: 'block',
    })
  }

  async showWhatWeDo(event) {
    event.preventDefault()
    this.setState({ whatWeDoVisibility: 'block' })
  }

  hideWhatWeDo = event => {
    event.preventDefault()
    this.setState({
      whatWeDoVisibility: 'none',
    })
  }
  hideAssociates = event => {
    event.preventDefault()
    this.setState({
      ourAssociatesVisibility: 'none',
    })
  }

  render() {
    return (
      <header>
        <img src={logo} alt="Gomez and Associates" />
        <span id="motto">
          <em>
            Giving Organizations and Individuals a Purpose - Not Just a Job
          </em>
        </span>

        <ul id="menu" className="navigation nav-top sf-js-enabled">
          <li className="page_item page-item-4">
            <Link to="/">Who We Are </Link>
          </li>

          <li
            className="page_item page-item-121"
            onMouseEnter={event => this.showWhatWeDo(event)}
            onMouseLeave={event => this.hideWhatWeDo(event)}
          >
            <Link to="/what-we-do">What We Do </Link>
            <WhatWeDo
              visible={this.state.whatWeDoVisibility}
              whatWeDoOnMouseLeave={this.hideWhatWeDo}
            />
          </li>
          <li className="page_item page-item-19">
            <Link to="/our-clients">Our Clients </Link>
          </li>
          <li className="page_item page-item-21">
            <Link to="/work-projects">Work Projects</Link>
          </li>
          <li
            className="page_item page-item-23 current_page_ancestor current_page_parent"
            onMouseEnter={event => this.showAssociates(event)}
            onMouseLeave={event => this.hideAssociates(event)}
          >
            <Link to="/our-associates">Our Associates</Link>
            <OurAssociates
              visible={this.state.ourAssociatesVisibility}
              ourAssociatesOnMouseLeave={this.hideAssociates}
            />
          </li>
          <li className="page_item page-item-15">
            <Link to="/contact-us">Contact Us </Link>
          </li>
        </ul>
      </header>
    )
  }
}

export default Header
